import Modernizr from 'modernizr';
import breakpoints from "../settings/breakpoints";

export default {
  init() {

    // Elements
    const $window = $(window);
    const $body = $('body');
    const $navMainToggle = $('#PortalNavToggle');

    // Menu toggle
    let desktop = Modernizr.mq(breakpoints.lmedium);
    $navMainToggle.on('click', function() {
      $body.toggleClass('nav-active');
    });
    $window.resize(function() {
      desktop = Modernizr.mq(breakpoints.lmedium);
      if (desktop) {
        $body.removeClass('nav-active');
      }
    });

    // Change CSS for Vimeo video which was added responsive
    function fixVimeoResponsive(){
      jQuery('iframe[width!="640"]').parent().parent().css('padding-bottom', 0);
        jQuery('iframe[width!="640"]').css('padding', '0 1.5% 0 1.5%');
    }

    fixVimeoResponsive();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/userPortal.js